import { LitElement, html, css } from 'lit';
import './outline_button';
import './modal';
import './cancel_button'
import './add_button';
import './orange_button';

class AddNotificationModal extends LitElement {
  static properties = {
    isModalOpen: { type: Boolean, reflect: true },
  }
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
    this.isModalOpen = false;
  } 
  updated(changedProperties) {
    
  }
  static styles = css`
  .date-range-announce {
    display: flex;
    margin-top: 64px;
    font-size: 12px;
    line-height: 150%;
    font-weight: 400;
    color: #A8ABA6;
  }
  .notice {
    display: flex;
    color: #A8ABA6;
    gap: 4px;
    font-family: "Noto Sans JP";
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    margin-bottom: 191px;
    text-align: start;
  }
  .asterisk {
    width: 16px;
  }
  .buttons {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
  }
  .search-availability-modal-body {
    margin-bottom: 64px;
    text-align: start;
    .availability-form-label {
      margin-bottom: 8px;
      font-size: 14px;
    }
    .end-date-form {
      margin-top: 24px;
    }
  }
  `
  close() {
    this.dispatchEvent(new CustomEvent('close'));
  }
  minDate() {
    const  todaySet = new Date();
    const YYYY = todaySet.getFullYear();
    const MM = ('00' + (todaySet.getMonth()+1)).slice(-2);
    const DD = ('00' + todaySet.getDate()).slice(-2);
    return YYYY + '-' + MM + '-' + DD + ' 00:00:00';
  }
  maxDate() {
    const  todaySet = new Date();
    todaySet.setDate(todaySet.getDate() + 30);
    const YYYY = todaySet.getFullYear();
    const MM = ('00' + (todaySet.getMonth()+1)).slice(-2);
    const DD = ('00' + todaySet.getDate()).slice(-2);
    return YYYY + '-' + MM + '-' + DD + ' 23:59:59';
  }
  clickAddButton(){
    if(this.startDate && !this.endDate){
      alert("終了日時を選択してください");
      return;
    }
    else if(!this.startDate && this.endDate){
      alert("開始日時を選択してください");
      return;
    }
    else if(new Date(this.startDate) >= new Date(this.endDate)){
      alert("終了日時は開始日時より後にしてください");
      return;
    }
    else if(new Date(this.endDate) - new Date() > 1000 * 60 * 60 * 24 * 30){
      alert("本日を含めて30日間より長い期間を設定できません");
      return;
    }
    else if(new Date(this.startDate) < new Date()){
      alert("過去の日時は設定できません");
      return;
    }
    else if(new Date(this.endDate) < new Date()){
      alert("過去の日時は設定できません");
      return;
    }

    this.dispatchEvent(new CustomEvent('add-notification',{
      detail: {
        startDate: this.startDate,
        endDate: this.endDate,
      }
    }));
    this.close();
  }
  handleStartDateInput(e) {
    this.startDate = e.target.value;
  }
  handleEndDateInput(e) {
    this.endDate = e.target.value;
  }
  render() {
    return html`
      <modal-template
        @close="${this.close}"
        .isOpen="${this.isModalOpen}"
      >
        <div slot="header">
          <div>期間を選択してください</div>
        </div>
        <div slot="content">
          <div class="search-availability-modal-body">
            <div class="start-date-form">
              <div class="availability-form-label">開始</div>
              <input type="datetime-local" .value="${this.startDate}" min="${this.minDate()}" max="${this.maxDate()}" @input="${this.handleStartDateInput}">
            </div>
            <div class="end-date-form">
              <div class="availability-form-label">終了</div>
              <input type="datetime-local" .value="${this.endDate}" min="${this.minDate()}" max="${this.maxDate()}" @input="${this.handleEndDateInput}">
            </div>
          </div>
          <div class="notice">
            <div>※</div>
            <div>
              期間を指定せずに追加した場合、1日1回、取得日から最大1ヶ月先までの【利用可能な空き枠がある日時】をまとめて通知します。この通知はマイページからOFFにするか、削除するまで続きます。
            </div>
          </div>
          <div class="buttons">
            <cancel-button @click="${this.close}"></cancel-button>
            <add-button @click="${this.clickAddButton}"></add-button>
          </div>
        </div>
      </modal-template>
    `;
  }
}
customElements.define('add-notification-modal', AddNotificationModal);